<template>
  <div class="template">
    <!-- <div style="width: 100%; display: flex; align-items: center">
      <el-input
        v-model="templateValue"
        placeholder="请输入备件名称"
        style="width: calc(100% - 60px)"
      ></el-input>
      <el-button style="width: 60px" type="primary" @click="openDialog"
        ><i class="el-icon-search"></i
      ></el-button>
    </div> -->
    <el-dialog
      title="选择备件"
      top="5vh"
      :visible.sync="dialogVisible"
      width="70%"
      append-to-body
      :before-close="handleClose"
    >
      <div class="dialog-top">
        <el-input
          v-model="searchData.Keyword"
          clearable
          placeholder="请输入备件编号/名称"
          style="width: 300px; margin-left: 10px"
        ></el-input>
        <el-button
          type="primary"
          @click="handleSearch"
          style="margin-left: 10px"
          >查询</el-button
        >
      </div>
      <!-- @selection-change="handleSelect" -->
      <div class="dialog-center" v-loading="loading">
        <el-table
          :data="tableData"
          ref="dialogTable"
          style="width: 100%"
          height="calc(100% - 40px)"
          :class="type == 'checkBox' ? 'checkBoxTable' : 'radioTable'"
          @selection-change="handleSelectionChange"
          @select="handleSelect"
          @row-click="handleRowClick"
        >
          <el-table-column label="" width="50" type="selection">
          </el-table-column>
          <el-table-column label="序号" width="50" type="index">
          </el-table-column>

          <el-table-column label="备件编号" align="center" prop="Code" sortable>
          </el-table-column>
          <el-table-column label="备件名称" align="center" prop="Name" sortable>
          </el-table-column>
          <el-table-column
            label="备件类型"
            align="center"
            prop="MaterialTypeName"
            sortable
          >
          </el-table-column>
          <el-table-column label="备件规格" align="center" prop="Spec" sortable>
          </el-table-column>
          <el-table-column
            label="单位"
            align="center"
            prop="storageName"
            sortable
          >
          </el-table-column>
          <el-table-column
            label="厂家"
            align="center"
            prop="Manufacturer"
            sortable
          >
          </el-table-column>
        </el-table>
        <div
          style="
            height: 40px;
            display: flex;
            align-items: center;
            justify-content: right;
          "
        >
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pagination.PageIndex"
            :page-sizes="pagination.PageSizes"
            :page-size="pagination.PageRows"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pagination.total"
          >
          </el-pagination>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dialogVisible: false,
      templateValue: '',
      searchData: {
        Keyword: '',
      },
      selectRows: [],
      pagination: {
        PageIndex: 1,
        PageRows: 20,
        PageSizes: [20, 40, 60, 100],
        total: 0,
      },
      tableData: [],

      loading: false,
      selectedRows: [],
    }
  },
  props: {
    type: { default: 'checkBox', require: false, type: String },
    MaterialType: { default: '', require: false, type: String },
  },
  methods: {
    confirm() {
      console.log(this.selectRows, '')
      if (this.selectRows.length <= 0) {
        return this.$notify.warning('请选择单位组')
      }
      this.$emit('select', [...this.selectRows])
      this.dialogVisible = false
    },
    handleRowClick(row, column, event) {
      if (this.type == 'checkBox') {
        this.$refs.dialogTable.toggleRowSelection(row)
        return
      }
      this.$refs.dialogTable.clearSelection()
      this.$refs.dialogTable.toggleRowSelection(row)
      this.selectRows = [row]
    },
    handleSelect(selection, row) {
      console.log(selection, row)

      if (this.type == 'checkBox') {
        this.selectRows = selection
        return
      }
      this.$refs.dialogTable.clearSelection()
      this.$refs.dialogTable.toggleRowSelection(row)
      this.selectRows = [row]
    },
    handleSelectionChange(val) {
      console.log(val)
      if (this.type == 'checkBox') {
        this.selectRows = val
        return
      }
    },
    getDataList() {
      this.selectedRows = []
      this.loading = true
      this.$http
        .post('/PB/PB_Material/QueryDataList', {
          PageIndex: this.pagination.PageIndex,
          PageRows: this.pagination.PageRows,
          SortField: 'CreateTime',
          SortType: 'Desc',
          Search: {
            ...this.searchData,
            MaterialTypeId: this.MaterialType || '',
          },
        })
        .then((resJson) => {
          this.loading = false
          this.tableData = resJson.Data
          this.pagination.total = resJson.Total
          this.$nextTick(() => {
            this.$refs.dialogTable.clearSelection()
          })
        })
    },
    handleSearch() {
      this.pagination.PageIndex = 1
      this.getDataList()
    },
    handleCurrentChange(PageIndex) {
      this.pagination.PageIndex = PageIndex
      this.getDataList()
    },
    handleSizeChange(PageRows) {
      this.pagination.PageIndex = 1
      this.pagination.PageRows = PageRows
      this.getDataList()
    },
    openDialog() {
      this.dialogVisible = true
      this.searchData.Keyword = ''
      this.handleSearch()
    },
    handleClose() {
      this.dialogVisible = false
    },
  },
  mounted() {},
  created() {},
  computed: {},
  watch: {
    value(newValue) {
      this.templateValue = newValue
    },
  },
}
</script>
<style lang="scss" scoped>
.template {
  width: 100%;
}
::v-deep .el-dialog__body {
  padding: 20px;
  padding-top: 10px;
}
::v-deep .el-dialog__title {
  font-weight: bold;
}
.dialog-top {
  line-height: 30px;
}
.dialog-center {
  height: calc(70vh - 30px);
}
::v-deep
  .radioTable
  .el-table__header-wrapper
  .el-table-column--selection
  .cell {
  display: none;
}
</style>
